import cn from 'classnames';
import { Icon } from 'ui';
import { DirectMessageButton } from '../direct-message-button';

const IconDirectMessageButton = ({
  legacyUserId,
  small = false,
  type = 'link-secondary',
}: {
  legacyUserId: string;
  small?: boolean;
  type?: 'link-secondary' | 'tertiary' | 'text';
}) => (
  <DirectMessageButton
    className={cn('icon-direct-message-button', { 'icon-direct-message-button--small': small })}
    icon={<Icon icon="comment-line" />}
    legacyUserId={legacyUserId}
    type={type}
  />
);

export default IconDirectMessageButton;
